/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/require-default-props */
/* eslint-disable no-param-reassign */
import { useRef, useEffect, TextareaHTMLAttributes } from 'react';

import { useField, SubmitHandler, FormHandles } from '@unform/core';
import { IconBaseProps } from 'react-icons';

import { Container } from './styles';

interface Props {
  name: string;
  label?: string;
}
type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & Props;

function Textarea({ name, label, ...rest }: TextareaProps) {
  const textareaRef = useRef(null);
  const { fieldName, defaultValue = '', registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: textareaRef,
      getValue: ref => {
        return ref.current.value;
      },
      setValue: (ref, value) => {
        ref.current.value = value;
      },
      clearValue: ref => {
        ref.current.value = '';
      },
    });
  }, [fieldName, registerField]);

  return (
    <div>
      {label && <label htmlFor={fieldName}>{label}</label>}

      <textarea
        ref={textareaRef}
        id={fieldName}
        defaultValue={defaultValue}
        {...rest}
      />

      {error && <span>{error}</span>}
    </div>
  );
}

export default Textarea;
